import { FileText, FileImage, Download, ExternalLink } from "lucide-react";
import { AuthImage } from "./AuthImage";
import { openSecureFile } from "../lib/api";

const isImage = (ct) => (ct || "").toLowerCase().startsWith("image/");
const isPdf = (ct, name) => (ct || "").toLowerCase().includes("pdf") || (name || "").toLowerCase().endsWith(".pdf");

/**
 * Galleria di allegati con thumbnail cliccabili.
 * - Immagini → miniatura autenticata (AuthImage). Click apre in nuova tab.
 * - PDF/altri → icona grande + nome file. Click apre in nuova tab.
 *
 * @param docs [{id, original_filename, content_type}] — array unificato
 * @param testidPrefix prefisso per data-testid
 * @param accent classe di colore per icone (default #7A193D)
 * @param size dimensione tile in px (default 96)
 */
export function AttachmentGallery({ docs, testidPrefix = "att", accent = "#7A193D", size = 96 }) {
  if (!docs || docs.length === 0) return null;
  const px = `${size}px`;
  return (
    <div className="flex flex-wrap gap-3" data-testid={`${testidPrefix}-gallery`}>
      {docs.map((d, idx) => {
        const label = d.original_filename || "allegato";
        const key = d.id || idx;
        const common = "group relative flex flex-col items-center text-center focus:outline-none";
        if (isImage(d.content_type)) {
          return (
            <button type="button" key={key} onClick={() => openSecureFile(`/files/${d.id}`)} title={label}
               data-testid={`${testidPrefix}-item-${d.id}`}
               className={common}>
              <div className="relative rounded-lg overflow-hidden border-2 border-slate-200 group-hover:border-brand shadow-sm" style={{ width: px, height: px }}>
                <AuthImage fileId={d.id} alt={label} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <ExternalLink className="w-6 h-6 text-white drop-shadow" />
                </div>
              </div>
              <div className="mt-1 text-xs text-slate-600 truncate max-w-[96px]" style={{ maxWidth: px }}>{label}</div>
            </button>
          );
        }
        const Icon = isPdf(d.content_type, label) ? FileText : FileImage;
        return (
          <button type="button" key={key} onClick={() => openSecureFile(`/files/${d.id}`)} title={label}
             data-testid={`${testidPrefix}-item-${d.id}`}
             className={common}>
            <div className="flex flex-col items-center justify-center rounded-lg border-2 border-slate-200 group-hover:border-brand bg-white shadow-sm" style={{ width: px, height: px }}>
              <Icon className="w-10 h-10" style={{ color: accent }} />
              <div className="mt-1 text-[10px] font-bold uppercase text-slate-500 tracking-wide">
                {isPdf(d.content_type, label) ? "PDF" : (d.content_type || "FILE").split("/").pop().toUpperCase().slice(0, 6)}
              </div>
              <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-1 shadow border border-slate-200 opacity-0 group-hover:opacity-100 transition-opacity">
                <Download className="w-3 h-3" style={{ color: accent }} />
              </div>
            </div>
            <div className="mt-1 text-xs text-slate-600 truncate" style={{ maxWidth: px }}>{label}</div>
          </button>
        );
      })}
    </div>
  );
}
